import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const monitoringsApi = {
    getMonitorings: (): Observable<Dtos.GetMonitoringsResponse> => {
        //Create the request.
        let request: Dtos.GetMonitorings = new Dtos.GetMonitorings();

        //Send request.
        const response: Promise<Dtos.GetMonitoringsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getMonitoringsByTrialInstitutionId: (trialInstitutionId: number): Observable<Dtos.GetMonitoringsByTrialInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetMonitoringsByTrialInstitutionId = new Dtos.GetMonitoringsByTrialInstitutionId();

        request.trialInstitutionId = trialInstitutionId;

        //Send request.
        const response: Promise<Dtos.GetMonitoringsByTrialInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getMonitoringById: (id: number): Observable<Dtos.GetMonitoringByIdResponse> => {
        //Create the request.
        let request: Dtos.GetMonitoringById = new Dtos.GetMonitoringById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetMonitoringByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setMonitoring: (monitoring: Dtos.Monitoring): Observable<Dtos.SetMonitoringResponse> => {

        let request: Dtos.SetMonitoring = new Dtos.SetMonitoring();

        request.monitoring = monitoring;

        // send request
        const response: Promise<Dtos.SetMonitoringResponse> = client.post(request);

        return Observable.from(response);
    },
    createMonitoring: (trialInstitutionId: number): Observable<Dtos.CreateMonitoringResponse> => {
        //Create the request.
        let request: Dtos.CreateMonitoring = new Dtos.CreateMonitoring();

        request.trialInstitutionId = trialInstitutionId;

        //Send request.
        const response: Promise<Dtos.CreateMonitoringResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateMonitoring: (monitoring: Dtos.Monitoring): Observable<Dtos.ValidateMonitoringResponse> => {

        let request: Dtos.ValidateMonitoring = new Dtos.ValidateMonitoring();

        request.monitoring = monitoring;

        // send request
        const response: Promise<Dtos.ValidateMonitoringResponse> = client.post(request);

        return Observable.from(response);
    }
}